import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  advertisement: {
    id: 't.advertisement',
    defaultMessage: 'Advertisement',
  },
  stationRightBack: {
    id: 't.stationRightBack',
    defaultMessage: 'Your station will be right back.',
  },
  whyAdsButton: {
    id: 't.whyAdsButton',
    defaultMessage: 'Why Ads?',
  },
  whyAdsModalTitle: {
    id: 't.whyAdsModalTitle',
    defaultMessage: 'Why Ads?',
  },
  whyAdsModalBody: {
    id: 't.whyAdsModalBody',
    defaultMessage:
      'Your free Pandora experience is powered by our advertisers. Listen without ad interruptions when you upgrade.',
  },
  whyAdsModalUpgradeButton: {
    id: 't.whyAdsModalUpgradeButton',
    defaultMessage: 'Upgrade',
  },
  whyAdsModalCancelButton: {
    id: 't.whyAdsModalCancelButton',
    defaultMessage: 'Not now',
  },
} as const);
